<div class='container'>
    <mat-card>
        <mat-card-title>ERRORS HISTORY</mat-card-title>
        <br />
        <div class='row'>
            <div class='offset-md-2 col-md-4 col-12'>
                <label for='from'>From</label>
                <mat-form-field appearance="standard">
                    <input matInput placeholder="dd/mm/yyyy" id='from'>
                </mat-form-field>
            </div>

            <div class='col-md-4 col-12'>
                <label for='to'>To</label>
                <mat-form-field appearance="standard">
                    <input matInput placeholder="dd/mm/yyyy" id='to'>
                </mat-form-field>
            </div>
            <div class='col-md-2 col-12'>
                <button mat-raised-button>Submit</button>
            </div>

        </div>
        <hr />

        <table mat-table [dataSource]="dataSource" class="mat-elevation">

            <!-- Position Column -->
            <ng-container matColumnDef="Date">
              <th mat-header-cell *matHeaderCellDef> Date </th>
              <td mat-cell *matCellDef="let element"> {{element.Date}} </td>
            </ng-container>
          
            <!-- Name Column -->
            <ng-container matColumnDef="Time">
              <th mat-header-cell *matHeaderCellDef> Time </th>
              <td mat-cell *matCellDef="let element"> {{element.Time}} </td>
            </ng-container>
          
            <!-- Weight Column -->
            <ng-container matColumnDef="Name">
              <th mat-header-cell *matHeaderCellDef> Name </th>
              <td mat-cell *matCellDef="let element"> {{element.Name}} </td>
            </ng-container>
          
            <!-- Symbol Column -->
            <ng-container matColumnDef="Info">
              <th mat-header-cell *matHeaderCellDef> Info </th>
              <td mat-cell *matCellDef="let element"> {{element.Info}} </td>
            </ng-container>
          
            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        </table>

    </mat-card>
</div>
